import { getCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next';
import Head from 'src/general/components/Head/Head';
import { useTranslation } from 'src/lib/translations';
import { TermsContent, TermsContentProps } from 'src/modules/TermsPageContent';
import { getStaticTermsOfServiceContent } from 'src/modules/TermsPageContent/staticContent';

interface TermsPageProps {
  content: TermsContentProps;
}

const TermsOfServicePage = ({ content }: TermsPageProps) => {
  const { t } = useTranslation();
  const { sections, title } = content;

  return (
    <>
      <Head
        description={t('Head.TermsPage.Description')}
        subtitle={t('Head.TermsPage.Subtitle')}
        title={t('Head.TermsPage.Title')}
      />
      <TermsContent sections={sections} title={title} />
    </>
  );
};

export async function getServerSideProps({
  req,
  res,
}: GetServerSidePropsContext) {
  const locale = (getCookie('language', { req, res }) as string) || 'en-US';
  const content = getStaticTermsOfServiceContent(locale);

  return {
    props: {
      content,
      locale,
    },
  };
}

export default TermsOfServicePage;
